import { OLAF, OZ } from 'HubStyleTokens/colors';
import I18n from 'I18n';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIIconCircle from 'UIComponents/icon/UIIconCircle';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import ProductFeatureLongLimit from './ProductFeatureLongLimit';
import TranslatedFeature from './TranslatedFeature';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FeatureTableCellWrapper = ({
  children
}) => {
  return /*#__PURE__*/_jsx("td", {
    className: "p-all-3",
    children: children
  });
};
const FeatureTableCell = ({
  feature,
  showTooltip = true,
  productLevel,
  levelIndex,
  onlyShowCurrentLongLimit
}) => {
  const hasDefaultLimit = Object.keys(feature.shouldUseDefaultLimits).some(key => key.includes(productLevel.toLocaleLowerCase()));
  const hasShortLimit = Object.keys(feature.shortLimits).some(key => key.includes(productLevel.toLocaleLowerCase()) && !!feature.shortLimits[key]);
  const cellApiName = feature.productApiNames[levelIndex];
  const hasFeature = hasDefaultLimit || hasShortLimit;
  if (!hasFeature) return /*#__PURE__*/_jsx(FeatureTableCellWrapper, {
    children: /*#__PURE__*/_jsx(UIIcon, {
      name: "minus",
      size: "xxs",
      screenReaderText: I18n.text('upgrades.featureTable.screenReader.featureUnavailable')
    })
  });
  const shouldShowLongLimitContent = () => {
    if (!Object.keys(feature.longLimits).length) {
      return false;
    }
    return onlyShowCurrentLongLimit ? !!feature.longLimits[cellApiName] : !!Object.keys(feature.longLimits).find(innerApiName => {
      return !!feature.longLimits[innerApiName];
    });
  };
  const longLimitContent = shouldShowLongLimitContent() ? /*#__PURE__*/_jsx(ProductFeatureLongLimit, {
    feature: feature,
    apiName: cellApiName,
    onlyShowCurrentLongLimit: onlyShowCurrentLongLimit
  }) : null;
  const hasTooltip = showTooltip && longLimitContent !== null;
  const shortLimitContent = hasShortLimit ? /*#__PURE__*/_jsx("div", {
    tabIndex: -1,
    style: hasTooltip ? {
      cursor: 'help'
    } : {},
    children: /*#__PURE__*/_jsx(TranslatedFeature, {
      productLevel: productLevel,
      feature: feature,
      attribute: "shortLimits"
    })
  }) : /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(UIIconCircle, {
      name: "success",
      color: OLAF,
      backgroundColor: OZ,
      borderWidth: 0,
      size: 8
    }), /*#__PURE__*/_jsx("span", {
      className: "sr-only",
      children: I18n.text('upgrades.featureTable.screenReader.featureAvailable')
    })]
  });
  return /*#__PURE__*/_jsx(FeatureTableCellWrapper, {
    children: hasTooltip ? /*#__PURE__*/_jsx(UITooltip, {
      use: "longform",
      placement: "left",
      disabled: !showTooltip,
      title: longLimitContent,
      children: shortLimitContent
    }) : shortLimitContent
  });
};
export default FeatureTableCell;